/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_V2_Share_CopiedInputs */

const en_notes_v2_share_copied = /** @type {(inputs: Notes_V2_Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note copied to clipboard`)
};

const es_notes_v2_share_copied = /** @type {(inputs: Notes_V2_Share_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota copiada al portapapeles`)
};

/**
* | output |
* | --- |
* | "Note copied to clipboard" |
*
* @param {Notes_V2_Share_CopiedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const notes_v2_share_copied = /** @type {((inputs?: Notes_V2_Share_CopiedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_V2_Share_CopiedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_notes_v2_share_copied(inputs)
	return en_notes_v2_share_copied(inputs)
});